export default "__VITE_ASSET__f6a2a3b1__"